import React, { useEffect } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  Calendar,
  ListChecks,
  Scale,
  TrendingUp,
  Radio,
  LogOut
} from 'lucide-react';

const navItems = [
  { path: '/', label: '运营概览', icon: LayoutDashboard, num: '01' },
  { path: '/planning', label: '直播策划', icon: Calendar, num: '02' },
  { path: '/live-data', label: '直播数据', icon: ListChecks, num: '03' },
  { path: '/comparison', label: '数据比对', icon: Scale, num: '04' },
  { path: '/analytics', label: '运营分析', icon: TrendingUp, num: '05' }
];

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <div className="noise-overlay" />
      <div className="flex min-h-screen">
        <aside className="w-72 shrink-0 border-r-2 border-border bg-background flex flex-col">
          {/* Logo */}
          <div className="border-b-2 border-border p-6">
            <NavLink to="/" className="flex items-center gap-3">
              <div className="w-10 h-10 bg-primary flex items-center justify-center">
                <Radio className="w-5 h-5 text-black" strokeWidth={2.5} />
              </div>
              <div className="flex flex-col leading-tight">
                <span className="font-space font-bold text-lg uppercase tracking-tight text-foreground">
                  LIVE/OP
                </span>
                <span className="text-xs text-muted-foreground uppercase tracking-widest">
                  直播运营系统
                </span>
              </div>
            </NavLink>
          </div>

          {/* 导航 */}
          <nav className="flex-1 py-4">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === '/'}
                className={({ isActive }) =>
                  `flex items-center gap-4 px-6 py-4 border-l-4 transition-all duration-200 group ${
                    isActive
                      ? 'bg-primary border-primary text-black'
                      : 'border-transparent text-foreground hover:bg-accent hover:border-border'
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <span
                      className={`font-space font-bold text-xs w-6 ${
                        isActive ? 'opacity-70' : 'opacity-50'
                      }`}
                    >
                      {item.num}
                    </span>
                    <item.icon className="w-5 h-5" strokeWidth={2} />
                    <span className="font-bold uppercase tracking-widest text-sm">
                      {item.label}
                    </span>
                  </>
                )}
              </NavLink>
            ))}
          </nav>

          {/* 底部用户区 */}
          <div className="border-t-2 border-border p-4">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 border-2 border-border bg-accent flex items-center justify-center font-space font-bold">
                OP
              </div>
              <div className="flex flex-col leading-tight">
                <span className="text-sm font-bold text-foreground">运营管理员</span>
                <span className="text-xs text-muted-foreground uppercase tracking-widest">
                  Operator
                </span>
              </div>
            </div>
            <button
              onClick={() => {
                if (confirm('确定退出登录吗?(本地演示版不会真的退出)')) {
                  window.location.reload();
                }
              }}
              className="w-full flex items-center gap-3 px-4 py-3 border-2 border-border text-muted-foreground hover:bg-destructive hover:text-white hover:border-destructive transition-colors duration-300 text-sm uppercase tracking-widest font-bold"
            >
              <LogOut className="w-4 h-4" />
              退出登录
            </button>
          </div>
        </aside>

        <main className="flex-1 min-w-0 overflow-auto">
          <div className="max-w-[95vw] mx-auto px-4 md:px-8 py-8">
            <Outlet />
          </div>
        </main>
      </div>
    </>
  );
}
